import theme from '../../base';

const dropdown = {
  background: theme.colors.neutrals.gray200,
  border: theme.colors.neutrals.gray200,
  foreground: theme.colors.neutrals.gray800,
  itemHover: theme.colors.neutrals.gray300,
  divider: theme.colors.neutrals.gray250,
};

export default dropdown;
